"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Side = void 0;
class Side {
    constructor(id) {
        this._id = id;
    }
    static fromId(id, strict = true) {
        const item = Side._values.find((it) => it._id === id);
        if (item) {
            return item;
        }
        if (strict) {
            throw new Error(`Invalid side id: ${id}`);
        }
    }
    static fromRaw(raw, strict = true) {
        const parsedValue = parseInt(raw, 10);
        return Side.fromId(parsedValue, strict);
    }
    toString() {
        return this._id;
    }
}
exports.Side = Side;
Side.Normal = new Side(1);
Side.Ex = new Side(2);
Side.Both = new Side(3);
Side._values = [Side.Normal, Side.Ex, Side.Both];
